import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from './logger.service';

/**
 * Registered once, app-wide, in `app/app.config.ts`.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);

  handleError(error: unknown): void {
    // Angular wraps some failures; unwrap so the stack we log is the real one.
    const cause = (error as { rejection?: unknown })?.rejection ?? error;
    this.logger.error('Uncaught error', cause);
  }
}
